module.exports = __webpack_public_path__ + "img/create-treatment-button-mobile-ru.604a2462.jpg";